import './style.scss'

import React, { Component } from 'react'
import moment from 'moment'
import { addToCart, removeFromCart } from 'cart'

import CartCounter from 'components/Cart/CartCounter'
import Price from 'components/Price'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import kebabCase from 'lodash/kebabCase'
import { push } from 'connected-react-router'
import { withTranslation } from 'react-i18next'

export class CartItem extends Component {
    render() {
        const { item, deadline, dispatch, view, deliveryDate, t } = this.props
        const {
            title,
            id,
            vendor,
            price,
            quantity,
            disabledForRegion,
            quantityPossible,
            supplier,
        } = item
        const soldOut = quantityPossible <= 0 || item.soldOut === '1'
        const tooMany = !soldOut && quantityPossible < quantity
        let mainImage
        if (item.navigationImage && item.navigationImage.small) {
            mainImage = item.navigationImage.small
        } else if (item.navigationImage && item.navigationImage.fullSize) {
            mainImage = item.navigationImage.fullSize
        }

        let deadlinePassed = false
        if (supplier) {
            const supplierDeadline = moment(supplier.deadline, 'hh:mm:ss').isBefore(deadline)
                ? moment(supplier.deadline, 'hh:mm:ss')
                : deadline
            deadlinePassed = moment(deliveryDate).isSame(moment().add(1, 'days'), 'day')
                ? moment().isAfter(supplierDeadline)
                : false
        }

        const urlName = kebabCase(title)
        const classes = classNames({
            'cart-item': true,
            'cart-item--disabled': disabledForRegion || soldOut || deadlinePassed,
            'cart-item--too-many': tooMany,
            [`cart-item--${view}`]: view,
        })
        return (
            <div className={classes}>
                <CartCounter
                    value={quantity}
                    title={title}
                    onIncrease={() => {
                        dispatch(addToCart(item))
                    }}
                    onDecrease={() => {
                        dispatch(removeFromCart(item))
                    }}
                    view={view}
                />
                <div className="cart-item__image">
                    <img src={mainImage} alt={title} />
                </div>
                <div
                    className="cart-item__text"
                    onClick={() => {
                        this.props.dispatch(push(`/product/${id}/${urlName}`))
                    }}
                >
                    <span className="cart-item__vendor">{vendor}</span>
                    <span className="cart-item__title">{title}</span>
                    {disabledForRegion && (
                        <span className="cart-item__note">
                            {t('cartCartItemDisabledForRegion')}
                        </span>
                    )}
                    {!disabledForRegion && soldOut && (
                        <span className="cart-item__note">{t('cartCartItemSoldOut')}</span>
                    )}
                    {!disabledForRegion && tooMany && (
                        <span className="cart-item__note">
                            {t('cartCartItemFewLeft', { quantityPossible })}
                        </span>
                    )}
                    {!disabledForRegion && deadlinePassed && (
                        <span className="cart-item__note">{t('cartCartItemDeadlinePassed')}</span>
                    )}
                </div>
                <Price className="cart-item__price" amount={price} />
            </div>
        )
    }
}

CartItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        vendor: PropTypes.string,
        price: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
        maxQuantity: PropTypes.number,
    }).isRequired,
    deadline: PropTypes.object,
    deliveryDate: PropTypes.string,
    view: PropTypes.string,
    quantity: PropTypes.number,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

export default connect()(withTranslation()(CartItem))
